import {cardLabels} from "../../../utils/utils.js";

const labels = cardLabels

const SosCards = ({ data: rawData, boName, className= "" }) => {
  const data = rawData ?? {};

  return(
    <>
      <div className={`grid grid-cols-3 gap-2 ${className}`}>

        <div className="mb-1">
          <div className="text-center">
            <div className="box boxCount">
              <h3>{labels[0]}</h3><h2>{data.registrations ?? 0}</h2>
            </div>
          </div>
        </div>

        <div className="mb-1">
          <div className="text-center">
            <div className="box">
              <h3>{labels[1]}</h3><h2>{data.events ?? 0}</h2>
            </div>
          </div>
        </div>

        <div className="mb-1">
          <div className="text-center">
            <div className="box">
              <h3>{labels[2]}</h3><h2>{data.dispatchs ?? 0}</h2>
            </div>
          </div>
        </div>

      </div>

      <div className="grid grid-cols-3 gap-2">

        <div className="mb-1 mt-1">
          <div className="text-center">
            <div className="box boxCount">
              <h3>{labels[3]}</h3><h2>{data.ind_arrested ?? 0}</h2>
            </div>
          </div>
        </div>

        <div className="mb-1 mt-1">
          <div className="text-center">
            <div className="box">
              <h3>{boName}</h3><h2>{data.bos ?? 0}</h2>
            </div>
          </div>
        </div>

        <div className="mb-1 mt-1">
          <div className="text-center">
            <div className="box">
              <h3>{labels[4]}</h3><h2>{data.avg_dispatch_time ?? "0s"}</h2>
            </div>
          </div>
        </div>

      </div>

      <div className="chart-divisor print:hidden"/>
    </>
  )
}

export default SosCards;